
import { Options, Vue } from 'vue-class-component';
import AuthService from "@/services/AuthService";
import FieldError from "@/components/forms/FieldError.vue";

type Form = {
    email: string,
};

// type FormErrors = Record<string, string[]>;

@Options({
    props: {

    },
    components: {
        FieldError,
    },
    emits: [
        'submitted',
        'close',
    ],
})
export default class PasswordResetRequestForm extends Vue {
    //preselectRegion?: number|null
    loading = false
    success = false

    error: string|null = null

    form: Form = {
        email: '',
    }

    submitForm() {
        if( this.loading || this.success ) {
            return;
        }

        this.loading = true;
        //const data = (({email, password, remember}) => ({email, password, remember}))(this.form); // create subset of object, to remove some reactive proxy stuff
        AuthService.passwordResetRequest(this.form.email).then(() => {
            this.success = true;
            this.error = null;
            this.$emit('submitted');
            // EventBusService.$emit('user.login');
        }).catch(error => {
            //console.warn(error);
            this.error = error?.response?.data?.error || 'Es ist ein Fehler aufgetreten. Bitte versuch es später noch einmal oder melde dich bei deiner Gebietsleiterin.';
        }).finally(() => this.loading = false);
    }

    mounted() {
        /*if( this.$store.loggedIn ) {
            NavigationService.navigateLoginSuccessful();
        }*/
    }
}
